import { useEffect } from "react";

import { getOrganizationId } from "Libs/utils";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { getOrganizationOrderThunk } from "../thunks/getOrganizationOrder.thunk";

type UseLoadOrderProps = {
  organizationId: string;
  orderId: string | undefined;
  includeDetails?: boolean;
};
export const useLoadOrder = ({
  organizationId,
  orderId,
  includeDetails
}: UseLoadOrderProps) => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state =>
    orderId ? state.organizationOrder.byId[orderId]?.loading : undefined
  );

  const order = useAppSelector(state =>
    orderId ? state.organizationOrder.byId[orderId]?.data : undefined
  );

  const rawData = useAppSelector(state => state.organizationOrder.byId);
  const orgId = useAppSelector(state =>
    getOrganizationId(state, organizationId)
  );

  useEffect(() => {
    if (!order && orgId && orderId) {
      dispatch(
        getOrganizationOrderThunk({
          organizationId: orgId,
          orderId,
          includeDetails
        })
      );
    }
  }, [orderId, orgId, includeDetails, order, dispatch]);

  return {
    order,
    loading,
    rawData
  };
};
